import { UserClass } from "@propelauth/react";

export class FusawareUser extends UserClass {
  constructor(userClass: UserClass) {
    super(
      {
        userId: userClass.userId,
        email: userClass.email,
        createdAt: userClass.createdAt,
        firstName: userClass.firstName,
        lastName: userClass.lastName,
        username: userClass.username,
        properties: userClass.properties,
        pictureUrl: userClass.pictureUrl,
        hasPassword: userClass.hasPassword,
        hasMfaEnabled: userClass.hasMfaEnabled,
        canCreateOrgs: userClass.canCreateOrgs,
        legacyUserId: userClass.legacyUserId,
        impersonatorUserId: userClass.impersonatorUserId,
      },
      userClass.orgIdToUserOrgInfo
    );
  }

  fusaHasPermission(permission: string) {
    const firstOrg = this.getOrgs()[0];
    if (!firstOrg) {
      return false;
    }
    return this.hasPermission(firstOrg.orgId, permission);
  }

  getOrgId() {
    const firstOrg = this.getOrgs()[0];
    if (!firstOrg) {
      return '';
    }
    return firstOrg.orgId;
  }
}

export enum FusawarePermission {
  MANAGE_PARTS = 'manage_parts',
  ACCESS_DEVELOPER_PORTAL = 'access_developer_portal',
  DELETE_TEMPLATE_PROCEDURE = 'delete_template_procedure',
  MANAGE_INPUT_SHAPES = 'manage_input_shapes',
  MANAGE_BLOCKS = 'manage_blocks',
  MANAGE_PROCEDURE_TEMPLATES = 'manage_procedure_templates',
  MANAGE_ALL_PROCEDURE_INSTANCES = 'manage_all_procedure_instances',
  MANAGE_IMPLEMENTATIONS = 'manage_implementations',
  MANAGE_ENTERPRISES = 'manage_enterprises',
  EDIT_HIERARCHY = 'edit_hierarchy',
  ADD_INTERFACES_TO_TEMPLATES = 'add_interfaces_to_templates',
  ACCESS_ADMIN_PAGE = 'access_admin_page',
  ACCESS_PROCEDURE_REQUIREMENT_TEST_METHOD = 'access_procedure_requirement_test_method',
  EXPORT_PROCEDURE_JSON = 'export_procedure_as_json',
  // Feature flag for the MCP server and its pages (docs/MCP.md). Nothing about
  // it is visible -- not even to admins -- without this permission.
  ACCESS_AI_ASSISTANT = 'access_ai_assistant'
}
